import React from "react";
import { Container, Button, Col } from "shards-react";
import SuccessImage from "../../assits/success.svg";
import { Link } from "react-router-dom";

export default () => {
  return (
    <Container fluid className="main-content-container px-4 pb-4">
      <div className="error">
        <div className="error__content">
          <Col md="6" className="d-none d-md-block">
            <img src={SuccessImage} alt="success pic" />
          </Col>
          <h3>votre demande a été enregistré </h3>
          <Link to="/">
            <Button pill>&larr; Go Home</Button>
          </Link>
        </div>
      </div>
    </Container>
  );
};
